import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 pb-24 pt-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500">
                <i className="ri-fire-fill text-lg text-background-50"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                91<span className="text-primary-500">.con</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              多元娱乐资讯与内容平台。聚合影视、综艺、音乐与热点新闻，为你提供丰富、及时、好读的娱乐内容体验。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-tiktok-fill", "ri-youtube-fill"].map((ic) => (
                <span
                  key={ic}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-400"
                >
                  <i className={ic}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-900">
              资讯分类
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/category/${c.key}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-400"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-900">
              快速导航
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {[
                { label: "视频资源", to: "/videos" },
                { label: "热点专题", to: "/special/s1" },
                { label: "搜索", to: "/search" },
                { label: "关于我们", to: "/about" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-900">
              联系我们
            </h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                contact@91con.com
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-feedback-line mt-0.5 text-primary-400"></i>
                内容纠错与反馈入口见
                <Link to="/about" className="text-accent-400 hover:underline">
                  关于我们
                </Link>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-400"></i>
                内容每日 09:00 - 24:00 持续更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 91.con 多元娱乐资讯与内容平台 · 本站内容均为前端演示数据</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>使用须知</span>
            <span>隐私提示</span>
            <span>内容均为演示，待后端数据接口接入</span>
          </p>
        </div>
      </div>
    </footer>
  );
}